import { WidgetsBroadcastMain } from '@/widgets/broadcast';

export const PagesBroadcastMain = () => <WidgetsBroadcastMain />;
